export const projects = [
	{
		name: "devrunner",
		label: "Devrunner",
		Component: null,
		description:
			"Devrunner is a collection of essential developer utilities designed to simplify common programming tasks.",
		appUrl: "https://devrunner.netlify.app/",
		devUrl: "https://github.com/pbesra/devrunner",
	},
];
